import React, { createContext, useContext } from 'react';

interface TriggerUpdateContextType {
  updatePatientListCount: number;
  updateClinicianProfileCount: number;
  updatePatientProfileCount: number;
  updateNotificationCount: number;
  triggerClinicianProfileUpdate: () => void;
  triggerPatientListUpdate: () => void;
  triggerPatientProfileUpdate: () => void;
  triggerNotificationUpdate: () => void;
  haveMoreData: boolean;
  resetHaveMoreData: (value: boolean) => void;
}
const TriggerUpdateContext = createContext<TriggerUpdateContextType>({
  updatePatientListCount: 0,
  updateClinicianProfileCount: 0,
  triggerClinicianProfileUpdate: () => {},
  triggerPatientListUpdate: () => {},
  updatePatientProfileCount: 0,
  triggerPatientProfileUpdate: () => {},
  updateNotificationCount: 0,
  triggerNotificationUpdate: () => {},
  haveMoreData: true,
  resetHaveMoreData: () => {},
});

export const TriggerUpdateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [haveMoreData, setHaveMoreData] = React.useState(true);
  const resetHaveMoreData = (value: boolean) => {
    setHaveMoreData(value);
  };
  const [updateClinicianProfileCount, setUpdateClinicianProfileCount] =
    React.useState(0);
  const [updatePatientListCount, setUpdatePatientListCount] = React.useState(0);
  const [updatePatientProfileCount, setUpdatePatientProfileCount] =
    React.useState(0);
  const [updateNotificationCount, setUpdateNotificationCount] =
    React.useState(0);

  const triggerClinicianProfileUpdate = () =>
    setUpdateClinicianProfileCount((prev) => prev + 1);

  const triggerPatientListUpdate = () =>
    setUpdatePatientListCount((prev) => prev + 1);

  const triggerPatientProfileUpdate = () =>
    setUpdatePatientProfileCount((prev) => prev + 1);

  const triggerNotificationUpdate = () =>
    setUpdateNotificationCount((prev) => prev + 1);

  const value = {
    triggerClinicianProfileUpdate,
    triggerPatientListUpdate,
    updateClinicianProfileCount,
    updatePatientListCount,
    updatePatientProfileCount,
    triggerPatientProfileUpdate,
    triggerNotificationUpdate,
    updateNotificationCount,
    haveMoreData: haveMoreData,
    resetHaveMoreData,
  };
  return (
    <TriggerUpdateContext.Provider value={value}>
      {children}
    </TriggerUpdateContext.Provider>
  );
};

export const useTriggerUpdate = () => useContext(TriggerUpdateContext);
